module.exports = __webpack_public_path__ + "img/F.Cs.6b9a8d7d.svg";